<template>
  <div
    class="offcanvas offcanvas-end"
    id="OffcanvasForm"
    ref="offcanvas"
    data-bs-backdrop="static"
  >
    <div class="bg-body-secondary border offcanvas-header py-2">
      {{ $t('Edit Shift') }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="border-bottom py-2 px-3">
        <div class="d-flex">
          <div class="row g-3 py-2">
            <b style="font-size: 18px;" class="mt-2">
              {{ data.branch }}
              <span
                style="text-transform: capitalize"
                :class="['badge', data.status == 'Open'? 'bg-success': 'bg-danger']"
              >
                <i
                  class="fas me-1"
                  :class="[data.status == 'Open'? 'fa-check-circle': 'fa-times-circle']"
                />
                {{ $t(data.status) }}
              </span>
            </b>
            <div
              class="d-flex mt-0 "
              style="font-size: 13px;"
            >
              <label
                class="pe-2"
              >
                {{ $t('Last Update') + ': ' + formatDateTime(data.updated_at) }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="px-3">
        <div class="row g-3 py-2">
          <div class="col-12">
            <label
              for="starting_cash"
              class="form-label"
            >
              {{ $t('Starting Cash') }}
              <span class="text-danger">*</span>
            </label>
            <div class="input-group-sm">
              <input
                id="starting_cash"
                type="number"
                inputmode="numeric"
                v-model.trim="v$.form.starting_cash.$model"
                class="form-control shadow-none text-end"
              >
              <div v-for="error of v$.form.starting_cash.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <label for="startedAt" class="form-label">
              {{ $t('Start Time') }}
              <span class="text-danger">*</span>
            </label>
            <input
              type="datetime-local"
              id="startedAt"
              class="form-control shadow-none"
              v-model.trim="v$.form.started_at.$model"
            >
            <div v-for="error of v$.form.started_at.$errors"
              class="d-block invalid-feedback"
              :key="error.$uid"
            >
              {{ error.$message }}
            </div>
          </div>
          <div class="col-12">
            <label for="note" class="form-label">
              {{ $t('Note') }}
            </label>
            <textarea
              class="form-control shadow-none"
              id="note"
              v-model.trim="v$.form.note.$model"
              style=" font-size: 14px;"
              :placeholder="$t('Note') + '...'"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading && hasPermission"
    >
      <ladda
        text="Save"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleUpdateShift"
      />
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import Ladda from '@/plugins/Ladda.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation";
import { Shifts } from '@/services/endpoint/pos.service';
import moment from "moment";

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation(this.form)
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
  },
  data() {
    let vm = this;
    return {
      loading: true,
      hasPermission: false,
      loadingSave: false,
      data: {},
      form: {
        starting_cash: '',
        started_at: '',
        note: ''
      }
    }
  },
  components: {
    PlaceholderContent,
    Ladda,
    AccessDenied,
  },
  methods: {
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    async fetchData() {
      await Shifts.getUpdate(this.id).then(res => {
        this.data = res.data.data;
        this.form.starting_cash = res.data.data.starting_cash;
        this.form.started_at = moment(res.data.data.opened_at).format('YYYY-MM-DDTHH:mm');
        this.form.note = res.data.data.note;
        this.hasPermission = true;
      }).catch(err => {
        this.hasPermission = false;
        this.loading = false;
			  throw err;
      });
    },
    setParamsBeforeSendUpdateShift() {
      let params = _.cloneDeep(this.form);
      params.started_at = moment(params.started_at).format('YYYY-MM-DD HH:mm:ss');
      return $.each(params, (key, value) => {
        if (value === null || value === "" || value.length === 0) {
          delete params[key];
        }
      });
    },
    async handleUpdateShift() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      await Shifts.update(this.id, this.setParamsBeforeSendUpdateShift()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Open Shift Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) {
          this.$toast.warn(err?.response?.data?.message);
        }
        this.loadingSave = false;
      });
    },
  },
  async mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas',async () => {
      this.loading = true;
      try {
        await this.fetchData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$emit('close');
    });
  },
  computed: {
  }
}
</script>
